import * as React from 'react';
import {styled} from '../../../utils';
import Flex from '../../../components/Flex';
import FormField from '../../../components/FormField';
import TextField from '../../../components/TextField';
import {PillButton, BaseButton} from '../../../components/Button';
import {IconCheckCircle} from '../../../components/SvgIcon';
import {FormikProps} from 'formik';
import {margin} from 'polished';

const ResendCodeLink = styled(BaseButton)(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.base,
  color: theme.color.primary,
  ...margin(10, 0, 100),
  ':hover': {
    textDecoration: 'underline'
  }
}));

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return <div style={{fontFamily: 'Roboto', color: '#C00', padding: '8px 0'}}>{children}</div>;
  }
  return null;
};

export interface FormValues {
  code: string;
}

interface CohostRegistrationVerificationFormBaseProps extends FormikProps<FormValues> {
  passed: boolean;
  failed: boolean;
  loading: boolean;
  handleCodeResend: () => void;
  resendingCode: boolean;
}

export default class CohostRegistrationVerificationFormBase extends React.Component<
  CohostRegistrationVerificationFormBaseProps,
  {}
> {
  public render() {
    const {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      handleCodeResend,
      resendingCode,
      passed,
      failed,
      loading
    } = this.props;

    // TODO: add success state to TextField component
    const checkCircle = <IconCheckCircle color="#08C173" />;

    return (
      <form onSubmit={handleSubmit}>
        <FormField label="Confirmation code">
          <TextField
            autoFocus={true}
            id="code"
            value={values.code}
            disabled={passed}
            icon={passed && checkCircle}
            onChange={handleChange}
            onBlur={handleBlur}
            large={true}
            iconPosition="end"
          />
          <ErrorMessage show={Boolean(errors.code && touched.code)}>{errors.code}</ErrorMessage>
          <ErrorMessage show={failed}>Invalid code.</ErrorMessage>
        </FormField>

        <Flex center={true} direction="column">
          <PillButton type="submit" variant="primary" large={true} loading={loading} disabled={passed}>
            Next step
          </PillButton>

          <ResendCodeLink onClick={handleCodeResend} disabled={resendingCode}>
            Or, resend code
          </ResendCodeLink>
        </Flex>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CohostRegistrationVerificationForm/private/CohostRegistrationVerificationFormBase.tsx